import { render, staticRenderFns } from "./FiltroLojaAberta.vue?vue&type=template&id=0f5f2c14&"
import script from "./FiltroLojaAberta.vue?vue&type=script&lang=js&"
export * from "./FiltroLojaAberta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports